const header = document.querySelector("header");

AOS.init({
  easing: "ease-in-out-cubic",
  duration: 600,
  offset: 200,
});

const headerHp = document.querySelector("header");

const getSingle = (id) => {
  return document.querySelector(id);
};

const getMultiple = (el) => {
  return document.querySelectorAll(el);
};

const body = document.querySelector("body");

const sliderArrivals = new Swiper(
  ".new-arrivals-slider .new-arrivals-slider-container",
  {
    slidesPerView: 1.6,
    spaceBetween: 16,
    // Navigation arrows
    navigation: {
      nextEl: ".new-arrivals-slider .arrow-next",
      prevEl: ".new-arrivals-slider .arrow-prev",
      disabledClass: "arrow-disabled",
    },
  }
);

const sliderReview = new Swiper(".review-slider .review-slider-container", {
  // Navigation arrows
  navigation: {
    nextEl: ".review-slider .arrow-next",
    prevEl: ".review-slider .arrow-prev",
    disabledClass: "arrow-disabled",
  },
});

function bottleInfo() {
  const btn = getMultiple(".bottle-info");
  const sheet = getSingle(".sheet-wrapper");

  function checkSheetOpen() {
    if (sheet) {
      if (!sheet.classList.contains("sheet-open")) {
        sheet.classList.add("sheet-open");
        body.style.overflow = "hidden";
      }
    }
  }

  btn.forEach((el) => {
    el.addEventListener("click", () => {
      checkSheetOpen();
    });
  });
}

function customBoxActive() {
  const customBox = getMultiple(".custom-box");
  customBox.forEach((el) => {
    const elButton = el.querySelector('[data-bs-toggle="collapse"]');
    elButton.addEventListener("click", () => {
      customBox.forEach((el) => {
        el.classList.remove("active");
      });

      if (elButton.getAttribute("aria-expanded") === "true") {
        el.classList.add("active");
      } else {
        el.classList.remove("active");
      }
    });
  });
}

function boxCartHeight() {
  let boxCart = getSingle(".box-cart");

  if (boxCart) {
    boxCart = boxCart.offsetHeight + 32;
    body.style.paddingBottom = `${boxCart}px`;
  }
}

function collapseHome() {
  const myCollapsible = getSingle(".accordion.accordion-space");
  const accordion = getMultiple(".accordion.accordion-space .accordion-item");

  if (myCollapsible) {
    myCollapsible.addEventListener("show.bs.collapse", (event) => {
      event.target.closest(".accordion-item").classList.add("active");
    });

    myCollapsible.addEventListener("hide.bs.collapse", (event) => {
      accordion.forEach((el) => {
        el.classList.remove("active");
      });
    });

    myCollapsible.addEventListener("shown.bs.collapse", (event) => {
      event.target.closest(".accordion-item").classList.add("active");
    });
  }
}

const headerHeight = () => {
  body.style.setProperty("--header-height", `${headerHp.offsetHeight}px`);
};

let capComponent = document.getElementById("cap");

const capHeight = () => {
  if (capComponent) {
    body.style.setProperty(
      "--cap-component-height",
      `${capComponent.offsetHeight}px`
    );
  }
};

function headerHpScroll() {
  if (window.scrollY > 90) {
    headerHp.classList.add("scrolled");
  } else {
    headerHp.classList.remove("scrolled");
  }
}

const sliderAboutUs = document.querySelector(".slider.slider-about-us");

const swiperAboutUs = new Swiper(sliderAboutUs, {
  slidesPerView: 1,
  spaceBetween: 10,

  breakpoints: {
    480: {
      slidesPerView: 1.8,
      spaceBetween: 30,
    },

    992: {
      slidesPerView: 1.86,
      spaceBetween: 50,
    },
  },

  scrollbar: {
    el: ".slider-scrollbar",
    draggable: true,
  },
});

swiperAboutUs.on("slideChange", function () {
  if (swiperAboutUs.isBeginning) {
    console.log("iniziato");
    sliderAboutUs.classList.add("mask-left");
    sliderAboutUs.classList.remove("mask-right");
  }

  if (swiperAboutUs.isEnd) {
    console.log("finito");
    sliderAboutUs.classList.add("mask-right");
    sliderAboutUs.classList.remove("mask-left");
  }
});

function parallaxBg() {
  var images = document.querySelectorAll(".parallax-bg img");
  images.forEach((image) => {
    new simpleParallax(image, {
      delay: 0.6,
      transition: "cubic-bezier(0,0,0,1)",
    });
  });
}

function parallaxHero() {
  var images = document.querySelectorAll(".hero");
  images.forEach((image) => {
    new simpleParallax(image, {
      delay: 0.6,
      transition: "cubic-bezier(0,0,0,1)",
      scale: 1,
    });
  });
}

function vantagesCardInit() {
  new Swiper(".slider__grid", {
    spaceBetween: 16,
    slidesPerView: 1.4,

    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
      enabled: true,
    },

    breakpoints: {
      768: {
        slidesPerView: 2.4,
        spaceBetween: 36,
      },

      992: {
        slidesPerView: 3,
        spaceBetween: 0,
        noSwiping: true,
        allowSlidePrev: false,
        allowSlideNext: false,

        scrollbar: {
          enabled: false,
        },
      },
    },
  });
}

function burgerClick() {
  if (header) {
    const burger = header.querySelector(".hamburger");

    burger.addEventListener("click", (e) => {
      if (body.classList.contains("header-open")) {
        body.classList.remove("header-open");
        burger.classList.remove("is-active");
      } else {
        body.classList.add("header-open");
        burger.classList.add("is-active");
      }
    });
  }
}

//Cap
function checkCap() {
  /* let capURL = "http://vyde.driink.it/?cap=";
	let capHP = document.getElementById("cap-check-hp").value;
	let capCheckHP = capURL.concat(capHP);



	document.getElementById("cap-btn-hp").onclick = function() {
		document.getElementById("cap-btn-hp").setAttribute("href", capCheckHP);
	};
   */

  const inputCapHp = document.getElementById("cap-check-hp");
  if (inputCapHp) {
    inputCapHp.addEventListener("keyup", logKeyHp);
    function logKeyHp(e) {
      document
        .getElementById("cap-btn-hp")
        .setAttribute(
          "href",
          `http://driink.vyde.it/location/check/${inputCapHp.value}`
        );
    }
  }
  const inputCap = document.getElementById("cap-check");
  if (inputCap) {
    inputCap.addEventListener("keyup", logKey);
    function logKey(e) {
      document
        .getElementById("cap-btn")
        .setAttribute(
          "href",
          `http://driink.vyde.it/location/check/${inputCap.value}`
        );
    }
  }
}

//Cookie
function setCookie(cookieName, cookieValue) {
  var d = new Date();
  d.setTime(d.getTime() + 90 * 24 * 60 * 60 * 1000); // 90 days
  document.cookie =
    cookieName + "=" + cookieValue + ";expires=" + d.toUTCString() + ";path=/";
}

function getCookie(cookieName) {
  var name = cookieName + "=";
  var i,
    c,
    ca = document.cookie.split(";");
  for (i = 0; i < ca.length; i++) {
    c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1);
    if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
  }
  return "";
}

// how to get the cookie
var cValue = getCookie("cart");
if (cValue == "full") {
  document.querySelector(".driink-cart").classList.add("filter-active");
} else {
  document.querySelector(".driink-cart").classList.remove("filter-active");
}

// aucomplete
function autocomplete(forms, arr) {
  /*the autocomplete function takes two arguments,
  the text field element and an array of possible autocompleted values:*/
  var currentFocus;

  forms.forEach((form) => {
    // Seleziona input comune
    const inp = form.querySelector("input");
    const submitLink = form.querySelector("a");

    /*execute a function when someone writes in the text field:*/
    inp.addEventListener("input", function (e) {
      var a,
        b,
        i,
        val = this.value;
      /*close any already open lists of autocompleted values*/
      closeAllLists();
      if (!val) {
        return false;
      }
      currentFocus = -1;
      /*create a DIV element that will contain the items (values):*/
      a = document.createElement("DIV");
      a.setAttribute("id", this.id + "autocomplete-list");
      a.setAttribute("class", "autocomplete-items");
      /*append the DIV element as a child of the autocomplete container:*/
      this.parentNode.appendChild(a);
      /*for each item in the array...*/
      for (i = 0; i < arr.length; i++) {
        /*check if the item starts with the same letters as the text field value:*/
        if (
          arr[i].comune.substr(0, val.length).toUpperCase() == val.toUpperCase()
        ) {
          /*create a DIV element for each matching element:*/
          b = document.createElement("DIV");
          /*make the matching letters bold:*/
          b.innerHTML =
            "<strong>" + arr[i].comune.substr(0, val.length) + "</strong>";
          b.innerHTML += arr[i].comune.substr(val.length);
          /*insert a input field that will hold the current array item's value:*/
          b.innerHTML +=
            "<input type='hidden' placeholder='" +
            arr[i].comune +
            "' value='" +
            arr[i].key +
            "'>";

          /*execute a function when someone clicks on the item value (DIV element):*/
          b.addEventListener("click", function (e) {
            const url = "http://test-shop.driink.it";

            /*insert the value for the autocomplete text field:*/
            inp.value = this.getElementsByTagName("input")[0].placeholder;
            submitLink.setAttribute(
              "href",
              `${url}/location/check/${
                this.getElementsByTagName("input")[0].value
              }`
            );

            //inp.value = this.getElementsByTagName("input")[0].value;
            /*close the list of autocompleted values,
              (or any other open lists of autocompleted values:*/
            closeAllLists();
          });
          a.appendChild(b);
        }
      }
    });

    /*execute a function presses a key on the keyboard:*/
    inp.addEventListener("keydown", function (e) {
      var x = document.getElementById(this.id + "autocomplete-list");
      if (x) x = x.getElementsByTagName("div");
      if (e.keyCode == 40) {
        /*If the arrow DOWN key is pressed,
        increase the currentFocus variable:*/
        currentFocus++;
        /*and and make the current item more visible:*/
        addActive(x);
      } else if (e.keyCode == 38) {
        //up
        /*If the arrow UP key is pressed,
        decrease the currentFocus variable:*/
        currentFocus--;
        /*and and make the current item more visible:*/
        addActive(x);
      } else if (e.keyCode == 13) {
        /*If the ENTER key is pressed, prevent the form from being submitted,*/
        e.preventDefault();
        if (currentFocus > -1) {
          /*and simulate a click on the "active" item:*/
          if (x) x[currentFocus].click();
        }
      }
    });
    function addActive(x) {
      /*a function to classify an item as "active":*/
      if (!x) return false;
      /*start by removing the "active" class on all items:*/
      removeActive(x);
      if (currentFocus >= x.length) currentFocus = 0;
      if (currentFocus < 0) currentFocus = x.length - 1;
      /*add class "autocomplete-active":*/
      x[currentFocus].classList.add("autocomplete-active");
    }
    function removeActive(x) {
      /*a function to remove the "active" class from all autocomplete items:*/
      for (var i = 0; i < x.length; i++) {
        x[i].classList.remove("autocomplete-active");
      }
    }
    function closeAllLists(elmnt) {
      /*close all autocomplete lists in the document,
    except the one passed as an argument:*/
      var x = document.getElementsByClassName("autocomplete-items");
      for (var i = 0; i < x.length; i++) {
        if (elmnt != x[i] && elmnt != inp) {
          x[i].parentNode.removeChild(x[i]);
        }
      }
    }
    /*execute a function when someone clicks in the document:*/
    document.addEventListener("click", function (e) {
      closeAllLists(e.target);
    });
  });
}

/*An array containing all the country names in the world:*/
var countries = [
  { comune: "Bergamo (Città Alta) (24129)", key: "5ebcc9c2-3f42-47b1-8dcd-7d3d6c90b94c" },
  { comune: "Bergamo (24128)", key: "9a8d6fb7-a0b1-4346-9178-d1012e81359c" },
  { comune: "Bergamo (24127)", key: "308c9f6b-7e04-457c-ab15-e0c6b66d156a" },
  { comune: "Bergamo (24126)", key: "80bc5c16-5b1d-431a-8280-7953c2f8fe5e" },
  { comune: "Bergamo (24125)", key: "f337d748-d2ec-4ada-96c0-c0a20d9539d1" },
  { comune: "Bergamo (24124)", key: "048bd983-ad0f-465f-9d2b-918ced813861" },
  { comune: "Bergamo (24123)", key: "696c5d8b-2ef5-4857-ab36-0113e32de06a" },
  { comune: "Bergamo (24122)", key: "26a0e2e1-8c0a-4533-8299-faac85a04068" },
  { comune: "Bergamo (24121)", key: "94d572a1-2734-4868-81e7-ac806260c13e" },
  { comune: "Bergamo (24100)", key: "06f7060e-a43a-4b12-9441-bd63e1b154b5" },
  { comune: "Seriate (24068)", key: "27d1ced8-7aad-4ac9-a2fb-ceb268d39313" },
  { comune: "Pedrengo (24066)", key: "9757d1f6-0a86-48bb-9e88-d3a5b8b88dcf" },
  { comune: "Albano Sant'Alessandro (24061)", key: "0c299dad-cf8d-4fbf-8cc0-d230f736c86a" },
  { comune: "Brusaporto (24060)", key: "eda5f888-16ef-490a-9405-9043a4ba47fd" },
  { comune: "Torre De' Roveri (24060)", key: "19ecb990-dcaf-42a4-8b6a-5ecc9af750cd" },
  { comune: "Costa Di Mezzate (24060)", key: "3a512731-6b85-4918-805f-d54eae4c500f" },
  { comune: "Bagnatica (24060)", key: "6d189a33-5797-4d33-900b-120c7911b9e3" },
  { comune: "Urgnano (24059)", key: "b9378f1b-9dc3-472c-91c8-d9aa65443c52" },
  { comune: "Cologno Al Serio (24055)", key: "07486770-578c-4800-b123-b5296e3d9f55" },
  { comune: "Azzano San Paolo (24052)", key: "c566a4ee-f41d-44bc-b77a-52b38d455109" },
  { comune: "Grassobbio (24050)", key: "43b9ebda-5a94-4176-9cc3-055fb84adcd6" },
  { comune: "Orio Al Serio (24050)", key: "da055808-578f-482d-a4b7-ccce46314d85" },
  { comune: "Zanica (24050)", key: "b34cdb0c-13a1-4fdb-8ed7-32229c2b19f9" },
  { comune: "Spirano (24050)", key: "30036e40-5ff2-492a-bfb5-e5c204230538" },
  { comune: "Ghisalba (24050)", key: "4dd82824-5171-4a87-8d44-07009931a811" },
  { comune: "Cavernago (24050)", key: "0ec4609a-d8f0-449c-b829-3f1e05c50657" },
  { comune: "Verdello (24049)", key: "13d1c298-d34e-47e5-ac0d-49418d6fed9a" },
  { comune: "Verdellino (24049)", key: "05adeb01-7c9a-43b6-8568-beb4153f7a62" },
  { comune: "Treviolo (24048)", key: "d20e1abc-814c-4381-961b-a5340701145a" },
  { comune: "Osio Sotto (24046)", key: "fe38f8f6-a53c-42aa-a0c9-b695ef50c4ec" },
  { comune: "Dalmine (24044)", key: "06a4b9c2-b6a7-432d-902c-5d59fc1769b1" },
  { comune: "Comun Nuovo (24040)", key: "20ebd429-6a97-4fb3-b10a-60cc929e40f1" },
  { comune: "Stezzano  (24040)", key: "4c223504-c123-456f-aa12-83a74f08da52" },
  { comune: "Lallio (24040)", key: "855e0953-b50b-4b96-a689-cf9c3d3b4cdc" },
  { comune: "Levate (24040)", key: "941c7c43-06ae-4da2-9778-c6e4bc1a98a4" },
  { comune: "Osio Sopra (24040)", key: "fbe79d19-2d51-412d-9c58-a6d972d21c7e" },
  { comune: "Verdellino (24040)", key: "985082ba-511b-484f-aaee-599af551cfa2" },
  { comune: "Pognano (24040)", key: "7fd42136-defa-48dd-8cec-fcb93096cab8" },
  { comune: "Bonate Sotto (24040)", key: "76af37b2-c213-461c-beaa-74689db834e2" },
  { comune: "Bonate Sopra (24040)", key: "d78e37aa-2157-4596-90ac-08a848b4182d" },
  { comune: "Madone (24040)", key: "e65797c8-52ea-4ae7-ad2d-be9314c26a28" },
  { comune: "Filago (24040)", key: "2bf2df5e-664c-4780-8cf1-f52db8e12ed8" },
  { comune: "Ponte San Pietro (24036)", key: "be2e49fe-6a0e-4df7-9be7-8d19f3da644d" },
  { comune: "Curno (24035)", key: "a9f022e8-f32c-4755-9737-8b7d709b08f0" },
  { comune: "Brembate Di Sopra (24030)", key: "c284120c-3fa8-4b0e-9c74-b468c38f6e0f" },
  { comune: "Paladina (24030)", key: "22ab9141-6875-4c08-954b-58891b8533bb" },
  { comune: "Valbrembo (24030)", key: "e9546515-b3e9-4463-b077-992fea2f5e2e" },
  { comune: "Mozzo (24030)", key: "b8089ac9-031c-4ae1-bcf7-1ed8d6107dae" },
  { comune: "Presezzo (24030)", key: "ef795134-e122-4b9c-8533-2e253737a7f8" },
  { comune: "Alzano Lombardo (24022)", key: "0006d466-253a-45f8-9702-03b94c8345a9" },
  { comune: "Gorle (24020)", key: "a3a26fe2-e1cc-4bdc-8eed-2b316b644737" },
  { comune: "Villa Di Serio (24020)", key: "e1778279-e918-4164-b53e-82cc59c124c8" },
  { comune: "Ranica (24020)", key: "b7a3db51-a706-4207-b757-77fd8bbedcd7" },
  { comune: "Scanzorosciate (24020)", key: "fce54b9e-ce5b-415f-a293-1d5cf822f0d4" },
  { comune: "Torre Boldone (24020)", key: "a2a7a779-0734-48f5-9768-d8cf56d16f77" },
  { comune: "Almè (24011)", key: "3244fd46-8a92-4391-bfb6-43530cb46ddb" },
  { comune: "Ponteranica (24010)", key: "b94b3e88-929f-4bd5-a870-54c759818b0f" },
  { comune: "Sorisole (24010)", key: "61797139-df58-45bb-b4a4-35b0cda9d3d0" },
];

/*initiate the autocomplete function on the "myInput" element, and pass along the countries array as possible autocomplete values:*/
autocomplete(document.querySelectorAll(".form-autocomplete"), countries);

window.addEventListener("DOMContentLoaded", (event) => {
  bottleInfo();
  boxCartHeight();
  customBoxActive();
  collapseHome();
  // headerHpScroll();
  headerHeight();
  parallaxBg();
  parallaxHero();
  vantagesCardInit();
  capHeight();
  checkCap();
  burgerClick();
});

window.addEventListener("resize", (event) => {
  headerHeight();
});

window.addEventListener("scroll", (event) => {
  // headerHpScroll();
});
